import React, {useEffect} from "react";
import "./App.css";
import {BrowserRouter as Router, Navigate, Route, Routes} from "react-router-dom";
import ProtectedRouteComponent from "./router/ProtectedRouteComponent";
import LoginScreen from "./features/login/components/LoginScreen";
import PlanMapScreen from "./features/plan/components/screen/PlanMapScreen";
import ShippingMapScreen from "features/shipping/components/screen/ShippingMapScreen";
import AuthRouteComponent from "./router/AuthRouteComponent";
import MenuTemplate from "./layouts/MenuTemplate";
import {MainTemplate} from "./layouts/MainTemplate";
import {AuthProvider} from "features/login/context/AuthProvider";

if (process.env.REACT_APP_STAGE === "PROD") {
  console.log = function no_console() {
  };
}

function App() {
  const appHeight = () => {
    const doc = document.documentElement;
    setTimeout(() => {
      if (doc) {
        let vh = window.innerHeight * 0.01;
        doc.style.setProperty("--vh", `${vh}px`);
      }
    }, 100);
  };
  
  const onContext = (e: any) => {
    // e.preventDefault();
  };
  
  const onBeforeAppInstalled = (e: any) => {
    e.preventDefault();
    window.install = e;
  };
  
  const onAppInstalled = () => {
    window.installed = true;
  };
  
  const onContentLoaded = () => {
    if (// @ts-ignore
      navigator?.standalone || window.matchMedia("(display-mode: standalone)").matches || window.matchMedia("(display-mode: fullscreen)").matches || window.matchMedia("(display-mode: minimal-ui)").matches) {
      window.installed = true;
    }
  };
  
  useEffect(() => {
    document.addEventListener("contextmenu", onContext);
    window.addEventListener("resize", appHeight);
    appHeight();
    window.addEventListener("beforeinstallprompt", onBeforeAppInstalled);
    
    if (!navigator.serviceWorker) {
      window.installed = true;
    }
    
    window.addEventListener("appinstalled", onAppInstalled);
    
    //but also add a listener. After app installation on desktop, the app will open in their own window right away.
    window.addEventListener("DOMContentLoaded", onContentLoaded);
    
    return () => {
      window.removeEventListener("resize", appHeight);
      window.removeEventListener("contextmenu", onContext);
      window.removeEventListener("beforeinstallprompt", onBeforeAppInstalled);
      window.removeEventListener("DOMContentLoaded", onContentLoaded);
      window.removeEventListener("appinstalled", onAppInstalled);
    };
  }, []);

  return (<Router>
    <AuthProvider>
      <Routes>
        <Route element={<MainTemplate />}>
          <Route element={<MenuTemplate />}>
            <Route path={"/box/plan"} element={<ProtectedRouteComponent showBreadTitle={false}>
              <PlanMapScreen />
            </ProtectedRouteComponent>} />
            <Route path={"/status/shipping"}
                   element={<ProtectedRouteComponent showBreadTitle={false}>
                     <ShippingMapScreen />
                   </ProtectedRouteComponent>} />
            <Route
              path="*"
              element={<Navigate to="/box/plan" replace />}
            />
          </Route>
          <Route path="/auth/login" element={<AuthRouteComponent>
            <LoginScreen />
          </AuthRouteComponent>} />
          <Route path="/auth/*" element={<Navigate to="/auth/login" replace />} />
          <Route
            path="*"
            element={<Navigate to="/box/plan" replace />}
          />
        </Route>
      </Routes>
    </AuthProvider>
  </Router>);
}

export default App;
